import React from 'react';
import Footer from '../Components/Footer';

const Confidentialite = () => {
  // Styles réutilisables
  const sectionStyle = {
    marginBottom: '2.5rem',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.05)'
  };

  const sectionHeaderStyle = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#ffffff',
    margin: 0,
    padding: '1.25rem 2rem',
    background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const sectionContentStyle = {
    padding: '1.5rem 2rem'
  };

  const paragraphStyle = {
    color: '#e2e8f0', 
    margin: '0 0 1rem 0',
    lineHeight: '1.7'
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    margin: '0 0 1rem 0'
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
    lineHeight: '1.7'
  };

  const highlightStyle = {
    color: '#0ea5e9',
    fontWeight: 600
  };

  const numberBadge = (number) => (
    <span style={{
      backgroundColor: '#0ea5e9',
      color: 'white',
      borderRadius: '9999px',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      fontWeight: 600,
      flexShrink: 0
    }}>
      {number}
    </span>
  );

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #111827 35%, #0b1220 100%)',
      color: 'white',
      padding: '2rem 0'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            color: '#ffffff',
            marginBottom: '1rem',
            background: 'linear-gradient(90deg, #0ea5e9, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            Politique de Confidentialité
          </h1>
          <p style={{
            fontSize: '1.125rem',
            color: '#94a3b8',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Dernière mise à jour : 31 octobre 2025
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ 
            padding: '2.5rem',
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.7) 100%)'
          }}>
            {/* Introduction */}
            <section style={{ 
              marginBottom: '3rem',
              padding: '2rem',
              background: 'rgba(15, 23, 42, 0.5)',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.05)'
            }}>
              <p style={{
                color: '#e2e8f0',
                lineHeight: '1.7',
                fontSize: '1.1rem',
                margin: 0
              }}>
                Chez AidFoundation, nous prenons la protection de vos données personnelles très au sérieux. Cette politique de confidentialité explique quelles données nous collectons, comment nous les utilisons et comment nous les protégeons.
              </p>
            </section>

            {/* Article 1 : Données collectées */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(1)}
                Données que nous collectons
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous collectons les types de données suivants lorsque vous utilisez nos services :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Informations personnelles :</span> nom, prénom, adresse email, numéro de téléphone, date de naissance, pièce d'identité.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Informations de compte :</span> identifiant, mot de passe, historique des connexions.
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Données de transaction :</span> historique des opérations, montants, bénéficiaires.
                  </li>
                  <li style={{...listItemStyle, marginBottom: 0}}>
                    <span style={highlightStyle}>Données techniques :</span> adresse IP, type de navigateur, appareil utilisé, données de navigation.
                  </li>
                </ul>
              </div>
            </section>

            {/* Article 2 : Utilisation des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(2)}
                Utilisation de vos données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>Nous utilisons vos données pour :</p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Fournir et gérer nos services bancaires</li>
                  <li style={listItemStyle}>Vérifier votre identité et prévenir la fraude</li>
                  <li style={listItemStyle}>Vous fournir un support client</li>
                  <li style={listItemStyle}>Améliorer nos services et développer de nouvelles fonctionnalités</li>
                  <li style={listItemStyle}>Respecter nos obligations légales et réglementaires</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Vous envoyer des informations importantes concernant votre compte</li>
                </ul>
              </div>
            </section>

            {/* Article 3 : Partage des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(3)}
                Partage de vos données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous ne partageons vos données personnelles qu'avec des tiers dans les cas suivants :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Prestataires de services :</span> pour nous aider à fournir nos services (hébergement, traitement des paiements, etc.)
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Obligations légales :</span> lorsque requis par la loi ou en réponse à des demandes légitimes des autorités
                  </li>
                  <li style={{...listItemStyle, marginBottom: 0}}>
                    <span style={highlightStyle}>Avec votre consentement :</span> pour des services spécifiques que vous avez demandés
                  </li>
                </ul>
              </div>
            </section>

            {/* Article 4 : Sécurité des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(4)}
                Sécurité de vos données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction. Ces mesures incluent :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Chiffrement des données sensibles</li>
                  <li style={listItemStyle}>Contrôles d'accès stricts</li>
                  <li style={listItemStyle}>Surveillance continue de nos systèmes</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Formation de nos employés</li>
                </ul>
              </div>
            </section>

            {/* Article 5 : Vos droits */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(5)}
                Vos droits
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Conformément à la réglementation sur la protection des données, vous disposez des droits suivants :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit d'accès :</span> accéder à vos données personnelles
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit de rectification :</span> corriger des données inexactes
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit à l'oubli :</span> demander la suppression de vos données
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit à la portabilité :</span> recevoir vos données dans un format structuré
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit d'opposition :</span> vous opposer au traitement de vos données
                  </li>
                  <li style={listItemStyle}>
                    <span style={highlightStyle}>Droit de limitation :</span> demander la limitation du traitement
                  </li>
                  <li style={{...listItemStyle, marginBottom: 0}}>
                    Pour exercer ces droits, veuillez nous contacter à l'adresse suivante :{' '}
                    <a href="mailto:donnees@unpaidfinancial.com" style={{color: '#0ea5e9', textDecoration: 'none'}}>
                      donnees@unpaidfinancial.com
                    </a>
                  </li>
                </ul>
              </div>
            </section>

            {/* Article 6 : Conservation des données */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(6)}
                Conservation des données
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Nous conservons vos données personnelles aussi longtemps que nécessaire pour fournir nos services et nous conformer à nos obligations légales. Les périodes de conservation varient selon les types de données et les finalités du traitement.
                </p>
                <p style={paragraphStyle}>
                  Par exemple :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Données de compte : 5 ans après la clôture du compte</li>
                  <li style={listItemStyle}>Données de transaction : 10 ans pour se conformer aux obligations comptables</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Données de connexion : 1 an</li>
                </ul>
              </div>
            </section>

            {/* Article 7 : Cookies et technologies similaires */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(7)}
                Cookies et technologies similaires
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Notre site utilise des cookies et des technologies similaires pour :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Assurer le bon fonctionnement du site</li>
                  <li style={listItemStyle}>Améliorer votre expérience utilisateur</li>
                  <li style={listItemStyle}>Analyser l'utilisation de nos services</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Personnaliser le contenu et les publicités</li>
                </ul>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Vous pouvez gérer vos préférences en matière de cookies via les paramètres de votre navigateur.
                </p>
              </div>
            </section>

            {/* Article 8 : Modifications de la politique */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(8)}
                Modifications de la politique de confidentialité
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Nous pouvons mettre à jour cette politique de confidentialité pour refléter les changements dans nos pratiques ou pour des raisons légales. Nous vous informerons de toute modification importante via notre site web ou par email.
                </p>
              </div>
            </section>

            {/* Article 9 : Nous contacter */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(9)}
                Nous contacter
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Si vous avez des questions concernant cette politique de confidentialité ou la manière dont nous traitons vos données, veuillez nous contacter à :
                </p>
                <p style={paragraphStyle}>
                  <span style={highlightStyle}>Email :</span>{' '}
                  <a href="mailto:vieprivee@unpaidfinancial.com" style={{color: '#0ea5e9', textDecoration: 'none'}}>
                    vieprivee@unpaidfinancial.com
                  </a>
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  <span style={highlightStyle}>Adresse postale :</span> AidFoundation, Service Protection des Données, 123 Avenue de la Banque, 75001 Paris, France
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Confidentialite;